import {Navigate, useParams} from "react-router-dom";
import React, {useState} from "react";
import Empty from "../../../Empty";
import {useDispatch} from "react-redux";
import Cookies from 'universal-cookie';

const cookieOptions = { maxAge: `${process.env.REACT_APP_COOKIE_BASKET_MAX_AGE}`, path: '/', domain: `${process.env.REACT_APP_COOKIE_DOMAIN}` }
const cookies = new Cookies(null, cookieOptions);

function AddItemReference () {
    let {reference} = useParams()
    let [canGo404, setCanGo404] = useState(false)
    let [canGoAdded, setCanGoAdded] = useState(false)
    let isConnected = cookies.get('connected');

    if (canGo404) {
        return (
            <Navigate to={"/error"}/>
        )
    }
    if (canGoAdded) {
        return (
            <Navigate to={isConnected ? "/basket" : "/validatebasket"}/>
        )
    }

    let request = new Request(process.env.REACT_APP_API_URL + '/client/article/exists/' + reference, {method:'POST', credentials:'include'})
    fetch(request).then((response) => {
        let json = {}
        try {
            json = response.json()
        } catch (e) {
            setCanGo404(true)
        }
        return json
    }).then((data) => {
        switch (data.type) {
            case 'OK':
                
                // Récupérer le cookie 'basketQuantity'
                let pastRef = cookies.get('basketQuantity');

                // Vérifier si la référence existe déjà dans l'objet
                if (pastRef[reference]) {
                    // Si oui, augmenter la quantité de 1
                    pastRef[reference] += 1;
                } else {
                    // Si non, ajouter la référence avec quantité 1
                    pastRef[reference] = 1;
                }

                // Mettre à jour le cookie avec le nouvel objet JSON
                cookies.set('basketQuantity', JSON.stringify(pastRef), cookieOptions);
                cookies.set('lastchanger', "client", cookieOptions);

                if (isConnected) {
                    let jsonProduct = new FormData()
                    jsonProduct.append("json", JSON.stringify([reference]))
            
                    let requestAdd = new Request(process.env.REACT_APP_API_URL + '/client/basket/add', { method: 'POST', credentials: 'include', body: jsonProduct })
                    fetch(requestAdd);
                    setCanGoAdded(true)
                }
                else{
                    setCanGoAdded(true)
                }
                break
            default:
                setCanGo404(true)
        }
    })
    return (
        <Empty/>
    )
}

export default AddItemReference;
